﻿import $ from "jquery";
import { GuiListGeneric } from "../GuiListGeneric";
export class GuiListAvalMatchingChoose extends GuiListGeneric {

    constructor() {
        super("GuiListAvalMatchingChoose");

    }

    protected attachListEvents() {
        super.attachListEvents();
        $("div.erz-list-element button.btn-add").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => { this.clickAdd(e); });
    }

    clickRow(): void {
        // keine Funktion in diesem Modul
    }


    // ret
    clickAdd(e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement> ) {
        this.log("clickCheck");
        e.stopPropagation();

        const clearoAvalMatchingId = $(e.target).data("id");
        const url = $("div.erz-list").data("select-url");

        const urlSelect = `${url}?clearoAvalMatchingId=${clearoAvalMatchingId}`;

        this.gotoUrl(urlSelect);
    }

}
